import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.a6c135a2-37b2-4c6f-8c3d-f6d4497fd2e3/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.a6c135a2-37b2-4c6f-8c3d-f6d4497fd2e3/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.a6c135a2-37b2-4c6f-8c3d-f6d4497fd2e3/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";
import React from 'react';
import debounce from 'lodash/debounce';
import { v4 as uuidv4 } from 'uuid';
import { FormInput, FormInputIcon, IconEmail, IconSearch, spacer12, spacer16, spacer4, spacer8, body1FontSize, body1LineHeight, cta4FontSize, cta4LineHeight } from '@spotify-internal/encore-web';
import { useRouter } from 'next/router';
import { Box, Link } from '../ui';
import styled from 'styled-components';
import { searchLoader } from './searchLoader';
import { useTracking } from '../Tracking';
import { useLocale, useT } from '@mrkt/features/i18n';
import { info } from '@mrkt/features/i18n/locales/info';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SUGGEST_DEBOUNCE_TIME = 300;
var FOOTER_LINK_URL = '/contact';
var SearchBarWrapper = styled(Box).attrs({
  noPadding: true
}).withConfig({
  displayName: "SearchBar__SearchBarWrapper",
  componentId: "sdogh5-0"
})(["margin-bottom:", ";background:transparent;input{font-size:", ";line-height:", ";}svg{margin-left:", ";}"], spacer16, body1FontSize, body1LineHeight, spacer4);
var SearchBox = styled(FormInput).withConfig({
  displayName: "SearchBar__SearchBox",
  componentId: "sdogh5-1"
})(["border-radius:", ";"], spacer4);
var Suggestions = styled.ul.withConfig({
  displayName: "SearchBar__Suggestions",
  componentId: "sdogh5-2"
})(["position:absolute;background:", ";padding-left:0;padding-right:0;border:1px solid ", ";border-top:0;margin-left:", ";z-index:1000;width:", ";max-height:50vh;overflow:auto;text-align:left;"], function (_ref) {
  var theme = _ref.theme;
  return theme.searchBar.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.searchBar.border;
}, spacer4, function (_ref3) {
  var width = _ref3.width;
  return "".concat(width - 8, "px");
});
var Suggestion = styled.li.withConfig({
  displayName: "SearchBar__Suggestion",
  componentId: "sdogh5-3"
})(["margin:0;padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";font-size:", ";line-height:", ";", "{", ";&:hover{color:", ";}}"], spacer8, spacer8, spacer16, spacer16, body1FontSize, body1LineHeight, Link, function (_ref4) {
  var selected = _ref4.selected,
      theme = _ref4.theme;
  return selected ? "color: ".concat(theme.link.hover) : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.link.hover;
});
var SuggestionHeader = styled.li.withConfig({
  displayName: "SearchBar__SuggestionHeader",
  componentId: "sdogh5-4"
})(["text-transform:uppercase;font-size:", ";line-height:", ";padding-top:", ";padding-left:", ";padding-right:", ";color:", ";"], cta4FontSize, cta4LineHeight, spacer12, spacer12, spacer12, function (_ref6) {
  var theme = _ref6.theme;
  return theme.searchBar.suggestionHeader;
});
var SuggestionFooter = styled(Suggestion).withConfig({
  displayName: "SearchBar__SuggestionFooter",
  componentId: "sdogh5-5"
})(["svg{margin-right:", ";vertical-align:-3px;color:", ";}"], spacer8, function (_ref7) {
  var theme = _ref7.theme;
  return theme.searchBar.icon;
});
export var SearchBar = function SearchBar(_ref8) {
  var _router$query, _info$locale$contentf, _info$locale, _router$query2, _input$current2;

  var _ref8$query = _ref8.query,
      query = _ref8$query === void 0 ? '' : _ref8$query,
      contentTypes = _ref8.contentTypes,
      _ref8$placeholder = _ref8.placeholder,
      placeholder = _ref8$placeholder === void 0 ? '' : _ref8$placeholder,
      _ref8$search = _ref8.search,
      search = _ref8$search === void 0 ? false : _ref8$search,
      _ref8$suggest = _ref8.suggest,
      suggest = _ref8$suggest === void 0 ? true : _ref8$suggest,
      _ref8$suggestCount = _ref8.suggestCount,
      suggestCount = _ref8$suggestCount === void 0 ? 10 : _ref8$suggestCount,
      _ref8$suggestInitial = _ref8.suggestInitial,
      suggestInitial = _ref8$suggestInitial === void 0 ? false : _ref8$suggestInitial,
      _ref8$suggester = _ref8.suggester,
      suggester = _ref8$suggester === void 0 ? searchLoader.load.bind(searchLoader) : _ref8$suggester,
      _ref8$getSuggestUrl = _ref8.getSuggestUrl,
      getSuggestUrl = _ref8$getSuggestUrl === void 0 ? function (sug) {
    return sug === null || sug === void 0 ? void 0 : sug.url;
  } : _ref8$getSuggestUrl,
      searchUrl = _ref8.searchUrl,
      _ref8$trackCategory = _ref8.trackCategory,
      trackCategory = _ref8$trackCategory === void 0 ? 'Search Bar' : _ref8$trackCategory,
      _ref8$showFooter = _ref8.showFooter,
      showFooter = _ref8$showFooter === void 0 ? true : _ref8$showFooter,
      forceLocale = _ref8.forceLocale;
  var t = useT();
  var defaultLocale = useLocale();
  var router = useRouter();
  var locale = forceLocale || ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.locale) || defaultLocale;
  var language = (_info$locale$contentf = (_info$locale = info[locale]) === null || _info$locale === void 0 ? void 0 : _info$locale.contentful) !== null && _info$locale$contentf !== void 0 ? _info$locale$contentf : info.en.contentful;

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  var input = React.useRef(null);

  var getInput = function getInput() {
    var _input$current, _input$current$value;

    return (_input$current = input.current) === null || _input$current === void 0 ? void 0 : (_input$current$value = _input$current.value) === null || _input$current$value === void 0 ? void 0 : _input$current$value.trim();
  };

  var debug = Boolean(router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.debug_search) || false;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      suggestions = _React$useState2[0],
      setSuggestions = _React$useState2[1];

  var _React$useState3 = React.useState(suggestInitial),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showSuggestions = _React$useState4[0],
      setShowSuggestions = _React$useState4[1];

  var _React$useState5 = React.useState(-1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selectedSuggestion = _React$useState6[0],
      setSelectedSuggestion = _React$useState6[1];

  var suggestUid = React.useRef(''); // make refs array for suggestions

  var sugRefs = React.useRef([]);
  React.useEffect(function () {
    sugRefs.current = sugRefs.current.slice(0, suggestions.length + (showFooter ? 1 : 0));
  }, [suggestions, sugRefs, showFooter]);
  var hideSuggestions = React.useCallback(function () {
    suggest && setShowSuggestions(false);
  }, [suggest, setShowSuggestions]);
  React.useEffect(function () {
    window.addEventListener('click', hideSuggestions);
    window.addEventListener('resize', hideSuggestions);

    var onKeyUp = function onKeyUp(e) {
      return suggest && e.key === 'Escape' && setShowSuggestions(false);
    };

    window.addEventListener('keyup', onKeyUp);
    return function () {
      window.removeEventListener('click', hideSuggestions);
      window.removeEventListener('resize', hideSuggestions);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [hideSuggestions, suggest]);
  var doSearch = React.useCallback(function () {
    var q = input.current.value;
    var url = "".concat(searchUrl || router.pathname, "?query=").concat(encodeURIComponent(q), "&locale=").concat(language);
    router.push(url);
  }, [input, router, language, searchUrl]);
  var updateSuggestions = debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var searchQuery, resp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            suggestUid.current = uuidv4();
            searchQuery = {
              uid: suggestUid.current,
              query: input.current.value,
              limit: suggestCount,
              suggest: true,
              locale: language,
              debug: debug,
              contentTypes: contentTypes
            };
            _context.next = 4;
            return suggester(searchQuery);

          case 4:
            resp = _context.sent;

            if (debug) {
              // eslint-disable-next-line no-console
              console.log('Search Response', resp);
            }

            setShowSuggestions(true);

            if (resp.error) {
              setSuggestions([]);
              sendEvent({
                eventCategory: "Frodor - Search Suggestions - ".concat(trackCategory),
                eventAction: 'error',
                eventLabel: "".concat(suggestUid.current || '?', " - ").concat(resp.error)
              });
            } else if (resp) {
              trackSuggestions(resp);
              setSuggestions(resp.hits.filter(Boolean));
            } else {
              setSuggestions([]);
            }

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), SUGGEST_DEBOUNCE_TIME);
  var resetSearch = React.useCallback(function () {
    if (suggest) {
      setShowSuggestions(suggestInitial);
      setSelectedSuggestion(-1);
      input.current.value = '';
    }
  }, [suggestInitial, input, setSelectedSuggestion, setShowSuggestions, suggest]); // scroll current suggestion into view

  React.useEffect(function () {
    var el = sugRefs.current[selectedSuggestion];
    if (el) el.scrollIntoView(false);
  }, [selectedSuggestion]);
  var trackSuggestions = React.useCallback(function (resp) {
    var _resp$hits;

    var hits = resp === null || resp === void 0 ? void 0 : (_resp$hits = resp.hits) === null || _resp$hits === void 0 ? void 0 : _resp$hits.filter(Boolean);

    if (!(hits !== null && hits !== void 0 && hits.length)) {
      sendEvent({
        eventCategory: "Frodor - Search Suggestions - ".concat(trackCategory),
        eventAction: 'view',
        eventLabel: "".concat(suggestUid.current || '?', " - No Results")
      });
    }

    hits.forEach(function (hit, idx) {
      var position = "[".concat(idx + 1, "/").concat(resp.hits.length, "]");
      sendEvent({
        eventCategory: "Frodor - Search Suggestions - ".concat(trackCategory),
        eventAction: 'view',
        eventLabel: "".concat(hit.searchUid, " - ").concat(resp.query || 'n/a', " - ").concat(position, " - ").concat(hit.url)
      });
    });
  }, [trackCategory]);
  return /*#__PURE__*/_jsxs(SearchBarWrapper, {
    children: [/*#__PURE__*/_jsx(FormInputIcon, {
      iconLeading: /*#__PURE__*/_jsx(IconSearch, {}),
      children: /*#__PURE__*/_jsx(SearchBox, {
        type: "text",
        "aria-label": t('FRODOR_4bcf48', 'search bar', ''),
        placeholder: placeholder,
        ref: input,
        defaultValue: query || '',
        onClick: function onClick(e) {
          e.stopPropagation();
          setShowSuggestions(getInput() || suggestInitial);
        },
        onKeyUp: function onKeyUp(e) {
          if (e.key === 'Enter') {
            // navigate to selected suggestion
            if (suggest && showSuggestions && suggestions && selectedSuggestion >= 0) {
              var _suggestions$selected;

              var url = selectedSuggestion === suggestions.length ? FOOTER_LINK_URL : (_suggestions$selected = suggestions[selectedSuggestion]) === null || _suggestions$selected === void 0 ? void 0 : _suggestions$selected.url;

              if (url) {
                router.push(url);
                resetSearch();
              }
            } else if (search) {
              doSearch();
            }
          } else if (suggest) {
            if (e.key === 'Escape') {
              setShowSuggestions(false);
            } else if (showSuggestions && e.key === 'ArrowDown') {
              e.stopPropagation();
              setSelectedSuggestion(function (i) {
                return i >= suggestions.length ? 0 : i + 1;
              });
            } else if (showSuggestions && e.key === 'ArrowUp') {
              setSelectedSuggestion(function (i) {
                return i <= 0 ? suggestions.length : i - 1;
              });
            } else if (e.key !== 'Escape') {
              updateSuggestions();
            }
          }
        }
      })
    }), suggest && showSuggestions && (getInput() || suggestInitial) && /*#__PURE__*/_jsxs(Suggestions, {
      width: ((_input$current2 = input.current) === null || _input$current2 === void 0 ? void 0 : _input$current2.clientWidth) || 300,
      "data-testid": "search-suggestions",
      children: [/*#__PURE__*/_jsxs(SuggestionHeader, {
        children: ["Results (", suggestions.length, ")"]
      }), suggestions.map(function (sug, idx) {
        return /*#__PURE__*/_jsxs(Suggestion, {
          selected: selectedSuggestion === idx,
          ref: function ref(el) {
            sugRefs.current[idx] = el;
          },
          children: [/*#__PURE__*/_jsx(Link, {
            track: ["Search Suggestion - ".concat(trackCategory, " - ").concat(sug.searchUid || '?', " - ").concat(getInput()), sug.url],
            href: "".concat(getSuggestUrl(sug), "&q=").concat(getInput()),
            children: sug.title
          }), debug && sug.score && " [".concat(sug.score.toFixed(2), "]")]
        }, sug.id);
      }), showFooter && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SuggestionHeader, {
          children: t('FRODOR_SEARCH_BAR_CANT_FIND', "Can't find what you're looking for?", 'To get help contact us using the button nearby')
        }), /*#__PURE__*/_jsx(SuggestionFooter, {
          selected: selectedSuggestion === suggestions.length,
          ref: function ref(el) {
            sugRefs.current[suggestions.length] = el;
          },
          children: /*#__PURE__*/_jsxs(Link, {
            href: "".concat(FOOTER_LINK_URL, "?q=").concat(getInput()),
            track: [trackCategory, "Contact Us - ".concat(suggestUid.current || '?', " - ").concat(getInput())],
            children: [/*#__PURE__*/_jsx(IconEmail, {
              iconSize: 16,
              "aria-hidden": true
            }), t('FRODOR_8dcde8', 'Contact us', '')]
          })
        })]
      })]
    })]
  });
};